// RecoverSafelySection.js
import React from "react";
import recoverSafelyImage from "../assets/recover-safely-image.jpg";

const RecoverSafelySection = () => {
  const services = [
    "Medication reminders to stay on track with your recovery plan",
    "Monitoring for changes in condition and reporting concerns",
    "Transportation to follow-up appointments",
    "Light housekeeping to maintain a clean and safe environment",
    "Meal preparation that aligns with post-surgery dietary needs",
    "Assistance with bathing, dressing, and personal hygiene",
    "Mobility support to reduce fall risk and promote movement as advised",
  ];

  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div>
            <img
              src={recoverSafelyImage}
              alt="Two women looking at tablet together"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Recover Safely and Comfortably with Trusted Post-Operative Care
            </h3>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-6">
              <p>
                Recovering from surgery can be physically and emotionally
                demanding—especially at home. Allawah Lodge offers personalised
                post-operative care to support a safe, comfortable recovery and
                help reduce the risk of complications.
              </p>

              <p className="font-normal">
                Our trained caregivers assist with a range of tasks during the
                healing process, including:
              </p>
            </div>

            <ul className="space-y-2 text-gray-700 font-light mb-6">
              {services.map((service, index) => (
                <li key={index} className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>{service}</span>
                </li>
              ))}
            </ul>

            <p className="text-gray-700 font-light leading-relaxed">
              Whether you need short-term help or ongoing support, we're here to
              make your recovery smoother and more manageable—so you can focus
              on healing.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecoverSafelySection;
